package co.maytes.standupbot.dashboard.features.setup

import co.maytes.standupbot.shared.dto.integration.FixActionDto
import co.maytes.standupbot.shared.dto.setup.CheckResultDto
import co.maytes.standupbot.shared.dto.setup.CheckStatusDto
import co.maytes.standupbot.shared.dto.setup.SetupCheckReportDto
import co.maytes.standupbot.shared.dto.setup.hasFailure
import co.maytes.standupbot.shared.dto.setup.isClean
import co.maytes.standupbot.shared.dto.setup.summaryLabel
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

enum class CheckGlyph { Pass, Warn, Fail, Skipped }

data class CheckRow(
    val title: String,
    val subject: String?,
    val detail: String,
    val glyph: CheckGlyph,
    val action: FixActionDto?,
) {
    val isFailure: Boolean get() = glyph == CheckGlyph.Fail
}

data class SetupCheckModel(
    val rows: List<CheckRow>,
    val summary: String,
    val ranAtLabel: String,
    val hasFailure: Boolean,
    val isClean: Boolean,
) {
    companion object {
        fun from(
            report: SetupCheckReportDto,
            zone: TimeZone,
        ): SetupCheckModel =
            SetupCheckModel(
                rows = report.checks.map(::row),
                summary = report.summaryLabel(),
                ranAtLabel = "ran ${clock(report, zone)}",
                hasFailure = report.hasFailure(),
                isClean = report.isClean(),
            )

        private fun row(check: CheckResultDto): CheckRow =
            CheckRow(check.title, check.subject, check.detail, glyph(check.status), check.fix)

        private fun glyph(status: CheckStatusDto): CheckGlyph =
            when (status) {
                CheckStatusDto.PASS -> CheckGlyph.Pass
                CheckStatusDto.WARN -> CheckGlyph.Warn
                CheckStatusDto.FAIL -> CheckGlyph.Fail
                CheckStatusDto.SKIPPED -> CheckGlyph.Skipped
            }

        private fun clock(
            report: SetupCheckReportDto,
            zone: TimeZone,
        ): String {
            val time = report.ranAt.toLocalDateTime(zone)
            return "${pad(time.hour)}:${pad(time.minute)}:${pad(time.second)}"
        }

        private fun pad(value: Int): String = value.toString().padStart(2, '0')
    }
}
